export const heading = 'We know more than just investments.';
export const body =
  'Health Care, housing, Social Security, and beyond — we can provide help with everything impacting your retirement. ';
